import React, { useState } from 'react';

import { useTranslation } from 'react-i18next';
import Heading from '../../../../../generic-components/Heading';
import { IssueDatePicker } from './IssueDatePicker';
import { DueDatePicker } from './DueDatePicker';
import { DATE_PICKER_TYPES, DUE_DATE_OPTIONS, STYLES } from '../../consts/consts';
import { useStore } from '../../../../../store';

const { INVOICE_CREATION: { INVOICE_DATES_PICKER: componentStyles } } = STYLES;

export const InvoiceDatesSection = () => {
  const invoiceData = useStore(state => state.invoiceData);
  const setInvoiceDataToUpdate = useStore(state => state.setInvoiceDataToUpdate);
  const [issueDate, setIssueDate] = useState<Date>(new Date());
  const { t } = useTranslation();

  const onIssueDateSelected = (date: Date, type: string) => {
    if (type === DATE_PICKER_TYPES.ISSUE_DATE) {
      if (invoiceData) {
        const dataToUpdate = { ...invoiceData };
        dataToUpdate.issueDate = date.toISOString();
        setInvoiceDataToUpdate(dataToUpdate);
      }
      setIssueDate(date);
    }
  };

  const onDueDateSelected = (date: Date, id: string) => {
    if (invoiceData) {
      const dataToUpdate = { ...invoiceData };
      dataToUpdate.invoicePaymentTerm.dueDate = date.toISOString();
      dataToUpdate.invoicePaymentTerm.dueDateDescription = id;
      setInvoiceDataToUpdate(dataToUpdate);
    }
  };

  return (
    <div className={componentStyles.CONTAINER}>
      <div className={componentStyles.CONTENT_WRAPPER}>

        <div className={componentStyles.PICKER_WRAPPER}>
          <Heading title={t('INVOICE_CREATION.INVOICE_DATES_SECTION.ISSUE_DATE')} className={componentStyles.PICKER_TITLE} />
          <IssueDatePicker onIssueDateSelected={onIssueDateSelected} />
        </div>

        <div className={componentStyles.PICKER_WRAPPER}>
          <Heading title={t('INVOICE_CREATION.INVOICE_DATES_SECTION.DUE_DATE')} className={componentStyles.PICKER_TITLE} />
          <DueDatePicker onDueDateSelected={onDueDateSelected} issueDate={issueDate} dueDates={DUE_DATE_OPTIONS} />
        </div>

      </div>
    </div>
  );
};
